import { allActivity } from "@/hooks/useActivity";
import { allMastery } from "@/hooks/useMastery";
import { allSrsEntries } from "@/hooks/useSrs";

/**
 * Download a full backup as JSON (version 3, the same file the mobile app
 * writes). The ledger alone can't rebuild a schedule or a streak, and activity
 * keeps its per-device keys so a restore stays mergeable.
 */
export function exportProgress(now = new Date()): void {
  const payload = {
    version: 3,
    exportedAt: now.toISOString(),
    mastery: allMastery(),
    srs: allSrsEntries(),
    activity: allActivity(),
  };
  const blob = new Blob([JSON.stringify(payload, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `lex30-progress-${now.toISOString().slice(0, 10)}.json`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
